import React from 'react';
import { Th, Thead, SearchInputCol } from './styles';
import { Tr } from '../styles';
import TableSelectMulti from './TableSelectMulti';

function TableHeader({
  columnNames,
  columns,
  columnButtons,
  advancedFilter,
  searchAdvanced,
  debouncedChangeAdvanced,
  advancedFilterOptions,
  setSearchTempAdvanced,
  searchTempAdvanced,
}) {
  const setFilterTemp = (key, value) => {
    setSearchTempAdvanced((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <Thead>
      <Tr>
        {columnNames.length
          ? columnNames.map((col, i) => <Th key={i}>{col}</Th>)
          : columns.map((col, i) => <Th key={i}>{col}</Th>)}
        {columnButtons.map((_, i) => (
          <Th key={i}></Th>
        ))}
      </Tr>
      {advancedFilter && (
        <Tr>
          {columns.map((col, i) => (
            <Th key={i}>
              {advancedFilterOptions[col] ? (
                <TableSelectMulti
                  value={searchTempAdvanced[col] ?? ''}
                  onChange={(value) => {
                    setFilterTemp(col, value);
                    debouncedChangeAdvanced(col, value);
                  }}
                  options={advancedFilterOptions[col]}
                  defaultValue={searchAdvanced[col]}
                />
              ) : (
                <SearchInputCol
                  type="text"
                  placeholder="Pesquisar..."
                  id="search"
                  value={searchTempAdvanced[col] ?? ''}
                  onChange={({ target: { value } }) => {
                    setFilterTemp(col, value);
                    debouncedChangeAdvanced(col, value);
                  }}
                />
              )}
            </Th>
          ))}
          {columnButtons.map((_, i) => (
            <Th key={i}></Th>
          ))}
        </Tr>
      )}
    </Thead>
  );
}

export default React.memo(TableHeader);
